'use client'

import { ReactNode } from 'react'
import classNames from 'classnames'

export default function NotificationContainer({
    children,
    position = 'top-right',
}: {
    children: ReactNode
    position?:
        | 'top-right'
        | 'top-left'
        | 'bottom-right'
        | 'bottom-left'
        | 'top-center'
}) {
    const positionClass = {
        'top-right': 'top-26 right-1/2 translate-x-1/2 items-end',
        'top-left': 'top-4 left-4 items-start',
        'top-center': 'top-70 right-4 items-end',
        'bottom-right': 'bottom-4 right-26 items-end',
        'bottom-left': 'bottom-10 left-1/2',
    }[position]

    return (
        <div
            className={classNames(
                'fixed z-50 flex flex-col gap-3',
                positionClass,
            )}
        >
            {children}
        </div>
    )
}
